"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * @phrospr/backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.6.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseRequestUpdatePlanningItemDataBody = void 0;
const partial_iplanning_item_data_entity_1 = require("./partial-iplanning-item-data-entity");
function parseRequestUpdatePlanningItemDataBody(data) {
    if (data.data !== null && typeof data.data === 'object')
        data.data = (0, partial_iplanning_item_data_entity_1.parsePartialIPlanningItemDataEntity)(data.data);
    return data;
}
exports.parseRequestUpdatePlanningItemDataBody = parseRequestUpdatePlanningItemDataBody;
